import { render } from "./PendingWorkOrders.vue?vue&type=template&id=c75588d0&scoped=true"
import script from "./PendingWorkOrders.vue?vue&type=script&lang=js"
export * from "./PendingWorkOrders.vue?vue&type=script&lang=js"

import "./PendingWorkOrders.vue?vue&type=style&index=0&id=c75588d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75588d0"]])

export default __exports__